// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"7da1acedde2c47d1","1836":"5f747f7aff78f052","5735":"beb578cc985d134d"}[chunkId] + ".css";
};